
import { createContext, useContext } from "react";
export const RefreshContext=createContext({
    handleRefresh:()=>{}
});
export const useRefresh=()=>useContext(RefreshContext)